import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-bookmarks',
  templateUrl: './help-bookmarks.component.html',
})
export class HelpBookmarksComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {
  }
  annot_header;
  annot_description;
  annot_para1header;
  annot_para1body;
  annot_para2header;
  annot_para2body;
  annot_para2SubHeader;
  annot_para2BodyList;
  annot_para2BodyEnd;
  annot_para3SubHeader;
  annot_para3Body;

  IsRightPanel: boolean;
  ngOnInit(): void {
    this.IsRightPanel = this.commonDataService.showRightPanel.getValue();

    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.getannotationlabels();
  }
  bookmark_Header;
  bookmark_HeaderDesc;
  bookmark_SubHeader1;
  bookmark_SubHeader1Body;
  bookmark_SubHeader2; bookmark_SubHeader2Body;
  getannotationlabels() {
    this.graphQlService.getHelp_Bookmarklabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        console.log(labels);
        this.bookmark_Header = labels.filter(x => x.key == "bookmark_Header").map(y => y.value);
        this.bookmark_HeaderDesc = labels.filter(x => x.key == "bookmark_HeaderDesc").map(y => y.value);
        this.bookmark_SubHeader1 = labels.filter(x => x.key == "bookmark_SubHeader1").map(y => y.value);
        this.bookmark_SubHeader1Body = labels.filter(x => x.key == "bookmark_SubHeader1Body").map(y => y.value);
        this.bookmark_SubHeader2 = labels.filter(x => x.key == "bookmark_SubHeader2").map(y => y.value);
        this.bookmark_SubHeader2Body = labels.filter(x => x.key == "bookmark_SubHeader2Body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }
}
